import { CurrencyPipe, NgFor, NgIf } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CartLine } from 'src/app/classes/utility';

@Component({
  selector: 'app-motivator',
  standalone: true,
  imports: [NgFor, NgIf, CurrencyPipe],
  templateUrl: './motivator.component.html',
  styleUrl: './motivator.component.scss',
})
export class MotivatorComponent implements OnChanges {
  @Input() theme: any;
  @Input() cart: any;
  @Input() totalQty: number = 0;

  gwp: any;

  ngOnChanges(changes: SimpleChanges): void {
    this.gwp = this.cart.lines.edges
      .map((x: any) => x.node)
      .find((y: CartLine) => y.attributes.find((x) => x.key == '_freegift'));
  }
}
